import { Menu } from '@monorepo/nova-ui';
import { alpha, Box, Divider, styled } from '@mui/material';

export const StyledDesktopProfileMenu = styled(Menu)(({ theme }) => ({
  '& .MuiPaper-root': {
    width: theme.spacing(62.5),
    marginTop: theme.spacing(3),
    borderRadius: theme.spacing(2),
    boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.1)',
  },

  '& .MuiList-root': {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.background.contrast,
  },

  '& .MuiMenuItem-root': {
    height: theme.spacing(9.5),
    paddingInline: theme.spacing(4),
    borderRadius: theme.spacing(1.5),

    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.2),
    },
  },

  '& .MuiMenuItem-root > .MuiBox-root': {
    display: 'inline-flex',
  },

  '& .MuiMenuItem-root > span': {
    marginTop: theme.spacing(0.5),
  },
}));

export const StyledMenuItemIcon = styled(Box)(({ theme }) => ({
  marginRight: theme.spacing(3),
}));

export const StyledMenuItemThemeSwitch = styled(Box)(({ theme }) => ({
  marginLeft: theme.spacing(-3),
  marginRight: theme.spacing(1),
}));

export const StyledProfileMenuDivider = styled(Divider)(({ theme }) => ({
  margin: `${theme.spacing(1.5)} 0`,
}));
